var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.5625C1.30078 5.5625 0.5625 6.33594 0.5625 7.25C0.5625 8.19922 1.30078 8.9375 2.25 8.9375C3.16406 8.9375 3.9375 8.19922 3.9375 7.25C3.9375 6.33594 3.16406 5.5625 2.25 5.5625ZM0.5625 1.90625C0.5625 2.85547 1.30078 3.59375 2.25 3.59375C3.16406 3.59375 3.9375 2.85547 3.9375 1.90625C3.9375 0.992188 3.16406 0.21875 2.25 0.21875C1.30078 0.21875 0.5625 0.992188 0.5625 1.90625ZM0.5625 12.5938C0.5625 13.543 1.30078 14.2812 2.25 14.2812C3.16406 14.2812 3.9375 13.543 3.9375 12.5938C3.9375 11.6797 3.16406 10.9062 2.25 10.9062C1.30078 10.9062 0.5625 11.6797 0.5625 12.5938Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/Menu_dots.a79e903c77f4f7be430abd9ef06e6a37.svg";
export { ForwardRef as ReactComponent };